module.exports = __webpack_public_path__ + "img/about_me_pic.113c8c33.jpg";